import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../utils/axiosInstance";
import MenuMain from "../../components/frontend/MenuMain";

class Wishlist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wishlist: [],
      currency_symbol: "",
    };
  }

  componentDidMount() {
    this.fetchFooterData();
    this.loadWishlist();
    window.addEventListener("wishlistUpdated", this.syncWishlist);
  }

  componentWillUnmount() {
    window.removeEventListener("wishlistUpdated", this.syncWishlist);
  }

  fetchFooterData = async () => {
    try {
      const res = await axios.get("/setting");
      const d = res?.data?.data;
      if (d) {
        this.setState({
          currency_symbol: d.currency_symbol || "",
        });
      }
    } catch (error) {
      console.error("Footer fetch error:", error);
    }
  };

  loadWishlist = () => {
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    this.setState({ wishlist });
  };

  syncWishlist = () => {
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    this.setState({ wishlist });
  };

  removeFromWishlist = (id) => {
    const wishlist = this.state.wishlist.filter((item) => item.id !== id);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
    this.setState({ wishlist });
    window.dispatchEvent(new Event("wishlistUpdated"));
  };

  addToCartFromWishlist = (item) => {
    let cart = JSON.parse(localStorage.getItem("cart")) || [];

    const exists = cart.find(c => c.id === item.id);

    if (exists) {
      cart = cart.map(c =>
        c.id === item.id ? { ...c, qty: c.qty + 1 } : c
      );
    } else {
      cart.push({
        id: item.id,
        name: item.name,
        price: Number(item.price),
        qty: 1,
        image: item.image
      });
    }

    localStorage.setItem("cart", JSON.stringify(cart));

    this.removeFromWishlist(item.id);
    window.dispatchEvent(new Event("cartUpdated"));
    window.dispatchEvent(new Event("wishlistUpdated"));

    alert("Moved to cart 🛒");
  };


  render() {

    const { wishlist, currency_symbol } = this.state;

    return (
      <>
        <MenuMain />

        <main className="main">
          {/* Breadcrumb */}
          <div className="page-header breadcrumb-wrap">
            <div className="container">
              <div className="breadcrumb">
                <Link to="/">
                  <i className="fi-rs-home mr-5" /> Home
                </Link>
                <span /> Shop <span /> Wishlist
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="container mb-30 mt-50">
            <div className="row">
              <div className="col-xl-10 col-lg-12 m-auto">
                <div className="mb-50">
                  <h1 className="heading-2 mb-10">Your Wishlist</h1>
                  <h6 className="text-body">
                    There are{" "}
                    <span className="text-brand">{wishlist.length}</span>{" "}
                    products in this list
                  </h6>
                </div>

                <div className="table-responsive shopping-summery">
                  <table className="table table-wishlist">
                    <thead>
                      <tr className="main-heading">
                        <th className="pl-30">Sl.</th>
                        <th>Img</th>
                        <th>Product</th>
                        <th>Price</th>
                        <th>Stock</th>
                        <th>Action</th>
                        <th className="end">Remove</th>
                      </tr>
                    </thead>

                    <tbody>
                      {wishlist.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            <h5>Your wishlist is empty ❤️</h5>
                          </td>
                        </tr>
                      ) : (
                        wishlist.map((item, index) => (
                          <tr key={item.id}>
                            <td className="pl-30">{index + 1}</td>
                            <td>
                              <img
                                src={item.image}
                                alt={item.name}
                                style={{ width: "70px" }}
                              />
                            </td>
                            <td>
                              <Link to={`/product/${item.id}`}>{item.name}</Link>
                            </td>
                            <td>
                              <h4 className="text-brand">{currency_symbol}{item.price}</h4>
                            </td>
                            <td>
                              {item.stock ? (
                                <span className="stock-status in-stock">
                                  In Stock
                                </span>
                              ) : (
                                <span className="stock-status out-stock">Out of Stock</span>
                              )}
                            </td>
                            <td>
                              <button
                                className="btn btn-sm"
                                onClick={() => this.addToCartFromWishlist(item)}>
                                Add to cart
                              </button>
                            </td>
                            <td className="text-center">
                              <button
                                onClick={() => this.removeFromWishlist(item.id)}
                                style={{ background: "none", border: "none" }}>
                                <i className="fi-rs-trash" />
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </main>
      </>
    );
  }
}

export default Wishlist;
